import { useEffect, useRef, useState } from "react";
import { liveAuctionSchedule } from "./liveAuctionSchedule";
/**
 * @param onAuctionEnded What the lot does when its auction ends: fetch itself again, like it does when its own
 * countdown reaches zero.
 */
export function useLiveAuction(auctionId, onAuctionEnded) {
    // The handler is registered once, but must always run the latest one.
    const onEndedRef = useRef(onAuctionEnded);
    onEndedRef.current = onAuctionEnded;
    const read = () => ({
        ready: liveAuctionSchedule.isReady(),
        isLive: liveAuctionSchedule.isLive(auctionId),
        isRegistered: liveAuctionSchedule.isRegistered(auctionId),
    });
    const [state, setState] = useState(read);
    useEffect(() => {
        const update = () => {
            const next = read();
            setState((prev) => (prev.ready === next.ready && prev.isLive === next.isLive && prev.isRegistered === next.isRegistered ? prev : next));
        };
        update();
        const unsubscribe = liveAuctionSchedule.subscribe(update);
        const unwatch = liveAuctionSchedule.watch(auctionId, onAuctionEnded ? () => { var _a; return (_a = onEndedRef.current) === null || _a === void 0 ? void 0 : _a.call(onEndedRef); } : undefined);
        return () => {
            unsubscribe();
            unwatch();
        };
    }, [auctionId]);
    return state;
}
